module.exports = __webpack_public_path__ + "static/media/visual-arts.3defa16b.jpg";